import React, { useState } from "react";
import { HeadingTagType, $createHeadingNode } from "@lexical/rich-text";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {$setBlocksType,} from '@lexical/selection';
import {
    $createParagraphNode,
    $getSelection,
    $INTERNAL_isPointSelection,
} from 'lexical';

// mui
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';

// type
const SupportedBlockType = {
    paragraph: "Paragraph",
    h1: "Heading 1",
    h2: "Heading 2",
    h3: "Heading 3",
    h4: "Heading 4",
    quote: "Quote",
    number: "Numbered List",
    bullet: "Bulleted List",
} as const;
type BlockType = keyof typeof SupportedBlockType;

const HeadingSelect = () => {
    const [blockType, setBlockType] = useState<BlockType>("paragraph");
    const [editor] = useLexicalComposerContext();

    const formatHeading = (headingSize: HeadingTagType) => {
        if (blockType !== headingSize) {
            editor.update(() => {
                const selection = $getSelection();
                if ($INTERNAL_isPointSelection(selection)) {
                    $setBlocksType(selection, () => $createHeadingNode(headingSize));
                }
            });
        }
    };

    const formatParagraph = () => {
        editor.update(() => {
            const selection = $getSelection();
            if ($INTERNAL_isPointSelection(selection)) {
                $setBlocksType(selection, () => $createParagraphNode());
            }
        });
    };

    const HeadingStyles = [
        { label: "段落", style: "paragraph" },
        { label: "見出し１", style: "h1" },
        { label: "見出し２", style: "h2" },
        { label: "見出し３", style: "h3" },
        { label: "見出し４", style: "h4" },
    ];

    const handleChangeHeading = (event: SelectChangeEvent) => {
        event.preventDefault();
        if (event.target.value === "paragraph") {
            formatParagraph();
        } else {
            formatHeading(event.target.value as HeadingTagType);
        }
        setBlockType(event.target.value as BlockType);
    };

    return (
        <FormControl sx={{ minWidth: 80 }} size="small">
            <InputLabel
                sx={{
                    fontSize: 14,
                    transform: "translate(14px, 7px) scale(1)",
                    [`&[data-shrink="true"]`]: {
                        transform: "translate(14px, -9px) scale(0.75)",
                    }
                }}
            >段落</InputLabel>
            <Select
                label="段落"
                value={blockType}
                onChange={handleChangeHeading}
                sx={{
                    [`&>.MuiSelect-select`]: {
                        py: 0.5,
                        fontSize: 14,
                    }
                }}
            >
                {HeadingStyles.map((type) => (
                    <MenuItem value={type.style} key={type.label}>{type.label}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default HeadingSelect;
